import { SUBSCRIPTION_ID_ATTRIBUTE } from "./constants";
import { getSubscription } from "./helpers";

export default class VbcAddons extends HTMLElement {
  static observedAttributes = [SUBSCRIPTION_ID_ATTRIBUTE];

  get tier() {
    return this.dataset.tier;
  }

  async attributeChangedCallback(name, _, value) {
    if (name === SUBSCRIPTION_ID_ATTRIBUTE && value) {
      const subscriptionId = Number(value);
      const subscription = await getSubscription(subscriptionId);

      // comrades get all addons
      if (
        !subscription?.product_title?.includes("Comrade") &&
        this.tier === "comrade"
      )
        this.style.display = "none";
    }
  }
}
